const Simplified = require("../models/main/Simplified.js");

// General utilities
const Sounds = require("../models/sounds/Sounds.js");
const SoundsPreferences = require("../models/sounds/SoundsPreferences.js");
const Localization = require("../models/Localization.js");
const Online = require("../models/available/Online.js");
const AvailabilityNotifier = require("../models/available/AvailabilityNotifier.js");
const SelfDestructor = require("../models/SelfDestructor.js");
const DesktopSounds = require("../models/sounds/DesktopSounds.js");
const LoadedSounds = require("../models/sounds/LoadedSounds.js");
const LoadChecker = require("../models/available/LoadChecker.js");
const MessageSound = require("../models/sounds/MessageSound.js");

// Keeping alive in the background                                  on iOS
const BackgroundSocket = require("../models/available/BackgroundSocket.js");
const NetworkStatus = require("../models/available/NetworkStatus.js");

// Stuff to do with calls
const Options = require("../models/desktop/Options.js");
const Toast = require("../models/notifications/Toast.js");

// Info about the current user
const PersonalData = require("../models/people/PersonalData.js");
const Header = require("../models/people/Header.js");
const TimezoneSetter = require("../models/people/TimezoneSetter");

const UpdateRefresher = require("../models/atouchaway/UpdateRefresher");
const Refresher = require("../models/atouchaway/Refresher.js");
const Reminders = require("../models/reminders/Reminders.js");
const RemindersHistory = require("../models/reminders/RemindersHistory.js");
const ActiveReminder = require("../models/reminders/ActiveReminder.js");
const ATouchAwaySettings = require("../models/atouchaway/ATouchAwaySettings.js");

const NewReading = require("../models/myhealth/NewReading.js");
const Comment = require("../models/myhealth/Comment.js");
const Groups = require("../models/groupchat/Groups.js");

// Bracelet stuff
const Bracelet = require("../models/bracelet/Bracelet.js");
const BraceletEvents = require("../models/bracelet/BraceletEvents.js");
const OwnBraceletEvents = require("../models/bracelet/OwnBraceletEvents.js");
const BraceletFinder = require("../models/bracelet/BraceletFinder.js");
const BraceletReconnector = require("../models/bracelet/BraceletReconnector.js");
const Bracelets = require("../models/bracelet/Bracelets.js");
const BraceletSettings = require("../models/bracelet/BraceletSettings.js");
const BraceletOwner = require("../models/bracelet/BraceletOwner.js");
const BraceletDisconnector = require("../models/bracelet/BraceletDisconnector.js");
const GroupMachines = require("../models/bracelet/GroupMachines.js");
const AvailableMachines = require("../models/bracelet/AvailableMachines.js");
const MachineEvents = require("../models/bracelet/MachineEvents.js");
const Bluetooth = require("../models/bluetooth/Bluetooth.js");
const BluetoothScanner = require("../models/bluetooth/BluetoothScanner.js");
const BluetoothOnOff = require("../models/bluetooth/BluetoothOnOff.js");
const MachineStateLogger = require("../models/bracelet/MachineStateLogger.js");
const MachineTracker = require("../models/atouchaway/MachineTracker");
const RemoteBraceletScanner = require("../models/bracelet/RemoteBraceletScanner.js");
const BraceletFindEvents = require("../models/bracelet/BraceletFindEvents.js");
const BraceletBatteryNotifier = require("../models/bracelet/BraceletBatteryNotifier.js");
const Overview = require("../models/myhealth/Overview.js");
const Activity = require("../models/myhealth/Activity.js");
const BloodSugar = require("../models/myhealth/BloodSugar.js");
const BloodPressure = require("../models/myhealth/BloodPressure.js");
const Weight = require("../models/myhealth/Weight.js");
const BloodOxygen = require("../models/myhealth/BloodOxygen.js");
const BodyTemperature = require("../models/myhealth/BodyTemperature.js");
const RemoteBluetoothScanner = require("../models/bluetooth/RemoteBluetoothScanner");

const DeviceGlucoseTNG = require("../models/myhealth/DeviceGlucoseTNG.js");
const DeviceActivity = require("../models/myhealth/DeviceActivity.js");
const DeviceTemperature = require("../models/myhealth/DeviceTemperature.js");

const OrientationLocker = require("../models/orientation/OrientationLocker.js");
const Size = require("../models/orientation/Size.js");
const TooSmall = require("../models/orientation/TooSmall.js");
const ScreenLocker = require("../models/atouchaway/ScreenLocker.js");
const ScreenSaver = require("../models/atouchaway/ScreenSaver.js");
const KeepAwake = require("../models/keepawake/KeepAwake.js");
const Keyboard = require("../models/atouchaway/Keyboard.js");
const FileViewer = require("../models/FileViewer.js");
const Backbutton = require("../models/Backbutton");
const AboutBox = require("../models/simplified/AboutBox.js");

// Workflow stuff
const ActiveWorkflowAction = require("../models/workflow/ActiveWorkflowAction.js");
const WorkflowActionAutoviewer = require("../models/workflow/WorkflowActionAutoviewer.js");
const WorkflowActions = require("../models/workflow/WorkflowActions.js");
const WorkflowDefinitions = require("../models/workflow/WorkflowDefinitions.js");
const WorkflowInstances = require("../models/workflow/WorkflowInstances.js");
const WorkflowActionPending = require("../models/workflow/WorkflowActionPending.js");

const MetawearScheduler = require("../models/myhealth/MetawearScheduler");
const MyHealthDevice = require("../models/myhealth/myHealthDevice");
const FeedbackModal = require("../models/notifications/FeedbackModal");
const OrgGroup = require("../models/forms/OrgGroup");
const PauseScreen = require("../models/atouchaway/PauseScreen");

const OwnResources = require("../models/resources/OwnResources");
const OwnResourcesList = require("../models/resources/OwnResourcesList");

const OwnStatus = require("../models/status/OwnStatus.js");
const OwnDevices = require("../models/devices/OwnDevices");
const DeviceFollowUp = require("../models/myhealth/DeviceFollowUp");

const License = require("../models/main/License");
const PrivacyPolicy = require("../models/main/PrivacyPolicy");

const DeviceOxygen = require("../models/myhealth/devices/bloodoxygen/DeviceOxygen");
const DeviceNonin3230 = require("../models/myhealth/devices/bloodoxygen/DeviceNonin3230");
const DeviceForaSPO2 = require("../models/myhealth/devices/bloodoxygen/DeviceForaSPO2");
const DeviceIHO2 = require("../models/myhealth/devices/bloodoxygen/DeviceIHO2");

const DeviceBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceBloodPressure");
const DeviceANDBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceA&DBloodPressure");
const DeviceIHBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceIHBloodPressure");
const DeviceBIOSBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceBIOSBloodPressure");

const DeviceWeight = require("../models/myhealth/devices/weight/DeviceWeight");
const DeviceANDWeight = require("../models/myhealth/devices/weight/DeviceA&DWeight");
const DeviceIHWeight = require("../models/myhealth/devices/weight/DeviceIHWeight");

const Reading = require("../models/simplified/Reading");

const Refresh = require("../models/main/Refresh");
const Logout = require("../models/main/Logout");

const Banners = require("../models/notifications/Banners");
const UnreadNotifications = require("../models/notifications/UnreadNotifications.js");
const UserMetrics = require("../models/usermetrics/UserMetrics.js");

const create = require("./create.js");

const PersistStorage = require("../models/persiststorage/PersistStorage");

const models = [
	Refresh,
	Logout,
	PersistStorage,
	ATouchAwaySettings,
	Simplified,
	Sounds,
	SoundsPreferences,
	Localization,
	Online,
	AvailabilityNotifier,
	SelfDestructor,
	DesktopSounds,
	LoadedSounds,
	LoadChecker,
	MessageSound,
	BackgroundSocket,
	NetworkStatus,
	Options,
	Toast,
	PersonalData,
	Header,
	TimezoneSetter,
	UpdateRefresher,
	Refresher,
	Reminders,
	RemindersHistory,
	ActiveReminder,
	NewReading,
	Comment,
	Groups,
	Bracelet,
	BraceletEvents,
	OwnBraceletEvents,
	BraceletFinder,
	BraceletReconnector,
	Bracelets,
	BraceletSettings,
	BraceletOwner,
	BraceletDisconnector,
	GroupMachines,
	AvailableMachines,
	MachineEvents,
	Bluetooth,
	BluetoothScanner,
	BluetoothOnOff,
	MachineStateLogger,
	RemoteBraceletScanner,
	BraceletFindEvents,
	BraceletBatteryNotifier,
	Overview,
	Activity,
	BloodSugar,
	BloodPressure,
	Weight,
	BloodOxygen,
	BodyTemperature,
	DeviceGlucoseTNG,
	DeviceActivity,
	DeviceTemperature,
	OrientationLocker,
	Size,
	TooSmall,
	ScreenLocker,
	ScreenSaver,
	KeepAwake,
	Keyboard,
	FileViewer,
	Backbutton,
	ActiveWorkflowAction,
	WorkflowActionAutoviewer,
	WorkflowActions,
	WorkflowDefinitions,
	WorkflowInstances,
	WorkflowActionPending,
	MetawearScheduler,
	MyHealthDevice,
	FeedbackModal,
	OrgGroup,
	PauseScreen,
	OwnResources,
	OwnResourcesList,
	OwnStatus,
	OwnDevices,
	DeviceFollowUp,
	License,
	PrivacyPolicy,
	AboutBox,
	DeviceOxygen,
	DeviceNonin3230,
	DeviceIHO2,
	DeviceForaSPO2,
	DeviceBloodPressure,
	DeviceANDBloodPressure,
	DeviceBIOSBloodPressure,
	DeviceIHBloodPressure,
	DeviceWeight,
	DeviceANDWeight,
	DeviceIHWeight,
	Reading,
	RemoteBluetoothScanner,
	MachineTracker,
	Banners,
	UnreadNotifications,
	UserMetrics,
];

module.exports = create(models, "simplified");